export const TOGGLE_STATUS_FIELDS = 'state.actions.cards.fields.TOGGLE_STATUS_FIELDS' as const;

export type ToggleStatusFieldsAction = {
	type: typeof TOGGLE_STATUS_FIELDS;
	payload: {
		hideStatusFields: boolean;
	};
};

export const toggleCardStatusFields = (hideStatusFields: boolean): ToggleStatusFieldsAction => ({
	type: TOGGLE_STATUS_FIELDS,
	payload: {
		hideStatusFields,
	},
});

export const TOGGLE_VERSION_FIELDS = 'state.actions.cards.fields.TOGGLE_VERSION_FIELDS' as const;

export type ToggleVersionFieldsAction = {
	type: typeof TOGGLE_VERSION_FIELDS;
	payload: {
		hideVersionFields: boolean;
	};
};

export const toggleCardVersionFields = (hideVersionFields: boolean): ToggleVersionFieldsAction => ({
	type: TOGGLE_VERSION_FIELDS,
	payload: {
		hideVersionFields,
	},
});

export const TOGGLE_EPIC_FIELDS = 'state.actions.cards.fields.TOGGLE_EPIC_FIELDS' as const;

export type ToggleEpicFieldsAction = {
	type: typeof TOGGLE_EPIC_FIELDS;
	payload: {
		hideEpicFields: boolean;
	};
};

export const toggleCardEpicFields = (hideEpicFields: boolean): ToggleEpicFieldsAction => ({
	type: TOGGLE_EPIC_FIELDS,
	payload: {
		hideEpicFields,
	},
});

export type Action = ToggleStatusFieldsAction | ToggleVersionFieldsAction | ToggleEpicFieldsAction;
